import React, { Component } from "react";
import MTWidget from "./index.js";
//import WidgetResidential from "./widgetresidential.js";
import Promise from 'promise-polyfill';

export default class WidgetSelection extends Component {
    constructor(props) {
        super();  
        this.state = {
            selectedGeo: "County:San Mateo",
            selectedPeriodType:"Quarter",
            selectedPeriod:"65",
          };    
        this._onGeoSelect = this._onGeoSelect.bind(this);     
        this._onPeriodSelect = this._onPeriodSelect.bind(this);
      }
      _onGeoSelect(e) {    
      
        this.setState({selectedGeo:e.target.value});      
    
      }


      _onPeriodSelect(e) {
        var selectedPeriodType = e.target.value;  
var selectedPeriod=selectedPeriodType=='Month'?'36':'65';

        this.setState({
          selectedPeriodType,selectedPeriod
          
        });
      
      }

  

      render() {
  
          var widgetselections = {              
       
            periodtype:this.state.selectedPeriodType,
            period:this.state.selectedPeriod,
            geo: [this.state.selectedGeo],
            classtype:'Residential - Single Family,Residential - Common Interest',
            divid: 'root',
            title:true
          };
          
        return(
          <div>
            <div id="trendWidgetHeaderWrap">
              <h1 className="font-weight-bold browser-default">Interactive Market Snapshots</h1>
            <select
            id="geo-select"
            className="custom-select w-25"
            value={this.state.selectedGeo}           
             onChange={_.throttle(this._onGeoSelect, 500, {'trailing': true}).bind(this)}>       
            <option key="1" value="County:San Mateo">
            San Mateo County
            </option>
            <option key="2" value="County:Santa Clara">
            Santa Clara County
            </option>
            <option key="3" value="County:Santa Cruz">
            Santa Cruz County
            </option>
            <option key="4" value="County:San Benito">
            San Benito County
            </option>
            <option key="5" value="County:Monterey">
            Monterey County
            </option>
          </select>


<div onChange={_.throttle(this._onPeriodSelect, 500, {'trailing': true}).bind(this)}> 

<div className="periodselect"><label><input type="radio" value="Quarter" name="period" defaultChecked={true}/> <span>All years by quarter</span></label></div>

<div className="periodselect"><label><input type="radio" value="Month" name="period" defaultChecked={false} /><span> 3 years by month</span></label></div>
</div>
</div>

<MTWidget widgetselections={widgetselections} />

</div>
)
      }

}





// WEBPACK FOOTER //
// ./src/WidgetSelection.js